<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="col-lg-4 col-md-6 ml-auto mr-auto">
              <card type="signup">
                <template slot="header">
                  <h4 class="card-title text-center">Login</h4>
                </template>
                <ValidationObserver ref="loginForm" v-slot="{ handleSubmit }">
                  <form>
                    <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                      <fg-input
                        :error="errors[0]"
                        v-model="form.email"
                        addon-left-icon="nc-icon nc-single-02"
                        placeholder="Email address"
                      ></fg-input>
                    </ValidationProvider>

                    <ValidationProvider name="password" rules="required|min:2" v-slot="{ errors }">
                      <fg-input
                        :error="errors[0]"
                        v-model="form.password"
                        addon-left-icon="nc-icon nc-key-25"
                        placeholder="Password"
                        type="password"
                      ></fg-input>
                    </ValidationProvider>

                    <p-button
                      native-type="submit"
                      slot="footer"
                      type="warning"
                      round
                      block
                      class="mb-3"
                      @click.prevent="handleSubmit(login)"
                    >Login</p-button>
                  </form>
                </ValidationObserver>

                <div>
                  <router-link :to="{name: 'reset-password'}">Forgot Password?</router-link>
                  <a href="" class="pull-right" @click.prevent="setPasswordModal">
                    Set Password
                  </a>
                </div>

              </card>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/background-2.jpg)"
        ></div>
      </div>
    </div>

    <!--  Set Password Modal -->
    <modal :show.sync="modals.classic" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">
        Set Password
      </h4>
      <ValidationObserver ref="resetForm">
        <form>
          <ValidationProvider name="name" rules="required|min:3" v-slot="{ errors }">
            <label>Reset Code</label>
            <fg-input addon-left-icon="nc-icon nc-single-02" :error="errors[0]" v-model="setPassword.code" placeholder="Code"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="password" rules="required|min:6" v-slot="{ errors }">
            <label>Password</label>
            <fg-input :error="errors[0]" v-model="setPassword.password"
              addon-left-icon="nc-icon nc-key-25" placeholder="Password" type="password"></fg-input>
          </ValidationProvider>

          <ValidationProvider name="password_confirmation" rules="required|min:6|confirmed:password" v-slot="{ errors }">
            <label>Confirm Password</label>
            <fg-input :error="errors[0]" v-model="setPassword.password_confirmation"
              addon-left-icon="nc-icon nc-key-25"
              placeholder="Confirm Password"
              type="password"></fg-input>
          </ValidationProvider>

        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click.prevent="closeModal">Cancel</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link  @click.prevent="setUserPassword">Set Password</p-button>
        </div>
      </template>
    </modal>

  </div>
</template>
<script>
import { Card, Checkbox, Button } from "src/components/UIComponents";
import Modal from "src/components/UIComponents/Modal.vue";
import AppNavbar from "./Layout/AppNavbar";
import AppFooter from "./Layout/AppFooter";

import Resource from "@/util/Api/resource.js";
const setPassResource = new Resource("auth/submit/passwordSet");

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    Modal,
  },
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      modals: {
        classic: false
      },
      setPassword:{
         code:'',
         password:'',
         password_confirmation:'',
      }
    };
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    },
    // login
    login() {
      this.$store
        .dispatch("user/login", this.form)
        .then(response => {
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("user", JSON.stringify(response.user));
          let user = JSON.parse(localStorage.getItem("user"));
          localStorage.setItem("userType", user[0].roleName);
          localStorage.setItem("id", user[0].id);

          // console.log('dataUser', user);

          this.$router.push({ path: "/" });
        }).catch(error => {
           this.showAlertMessage("The login credentials seems not to exist, please check and try again", "error");
        });
    },
    // clear fields
    clearField(){
       this.setPassword.code = "";
       this.setPassword.password = "";
       this.setPassword.password_confirmation = "";
    },
    // show reset password modal
    setPasswordModal() {
       this.clearField();
       this.modals.classic = true;
    },
    // close modal
    closeModal() {
      this.modals.classic = false;
    },
    // seting user password method
    async setUserPassword(){
       let formData = new FormData();
       formData.append("emailVerificationCode", this.setPassword.code);
       formData.append("password", this.setPassword.password);

       await setPassResource.store(formData)
       .then((response) => {
            this.closeModal();
            this.showAlertMessage(response.data.message, "success");
            this.clearField();
            this.$router.go();
       }).catch((error) => {
            if (error.response.status == 422) {
                let keys = Object.keys(error.response.data.message);
                this.showAlertMessage(error.response.data.message[keys[0]][0], "error");
            } else {
                this.showAlertMessage(error.response.data.message, "error");
            }
       });
    },
    // Message alert
    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },

  },

  beforeDestroy() {
    this.closeMenu();
  }
};
</script>
<style>
</style>
